// extracted by mini-css-extract-plugin
export default {"container":"Template_container__p1AXC","topPanelContainer":"Template_topPanelContainer__k+08k","childContainer":"Template_childContainer__pf9UH"};